export default __webpack_public_path__ + "static/media/PhoneMockup.18eafa58.png";